import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import CardView from "./Card";
import WinHighlight from "./WinHighlight";
import { topCard, BOARD_DIM, PLAYERS } from "../lib/quattro";

export default function Board({ state, legalSet, onCellClick, mode }) {
  // legalSet: Set of "r,c" strings highlighting playable cells
  const winSet = new Set((state.winLine || []).map(([r, c]) => `${r},${c}`));

  return (
    <div
      style={{
        position: "relative",
        width: "min(86vh, 100%)",
        maxWidth: 720,
      }}
    >
      <div
        className="grid"
        style={{
          gridTemplateColumns: `repeat(${BOARD_DIM}, 1fr)`,
          gap: 8,
          width: "100%",
          aspectRatio: "1 / 1",
        }}
        data-testid="game-board"
      >
      {state.board.map((row, r) =>
        row.map((cell, c) => {
          const key = `${r},${c}`;
          const top = topCard(cell);
          const isLegal = legalSet?.has(key);
          const isWin = winSet.has(key);
          const winColor = isWin && top ? PLAYERS[top.owner].color : undefined;
          return (
            <div
              key={key}
              className={[
                "cell-base no-select",
                isLegal ? "cell-legal" : "",
                cell.blocked ? "cell-blocked" : "",
                isWin ? "cell-win" : "",
              ].join(" ")}
              style={{
                color: winColor,
                borderColor: isWin ? winColor : undefined,
              }}
              onClick={() => isLegal && onCellClick && onCellClick(r, c)}
              data-testid={`cell-${r}-${c}`}
            >
              {cell.blocked && (
                <div
                  style={{
                    color: PLAYERS[cell.blockedBy ?? 0].color,
                    fontSize: 22,
                    fontWeight: 900,
                    textShadow: `0 0 12px ${PLAYERS[cell.blockedBy ?? 0].glow}`,
                  }}
                >
                  ✦
                </div>
              )}
              <AnimatePresence>
                {top && (
                  <motion.div
                    key={top.id + ":" + cell.stack.length}
                    initial={{ scale: 1.25, rotateZ: -8, opacity: 0 }}
                    animate={{ scale: 1, rotateZ: 0, opacity: 1 }}
                    exit={{ scale: 0.8, opacity: 0 }}
                    transition={{ type: "spring", stiffness: 260, damping: 20 }}
                    style={{ position: "absolute", inset: 6, pointerEvents: "none" }}
                  >
                    <CardView card={top} glow={isLegal || isWin} />
                    {cell.stack.length > 1 && (
                      <div className="card-stack-count" data-testid={`stack-${r}-${c}`}>
                        x{cell.stack.length}
                      </div>
                    )}
                  </motion.div>
                )}
              </AnimatePresence>
              {isLegal && !top && (
                <div style={{
                  position: "absolute", inset: 8, border: "2px dashed rgba(255,255,255,.5)",
                  borderRadius: 10, pointerEvents: "none",
                }} />
              )}
            </div>
          );
        })
      )}
      </div>
      {state.winLine && state.winner != null && (
        <WinHighlight winLine={state.winLine} winnerId={state.winner} />
      )}
    </div>
  );
}
